
<!--
/*******************************************************************************
*@ 컴포넌트명   : Dropdown.vue
*@ 컴포넌트설명 : dropdown 공통컴포넌트 (하단에서 위로 펼쳐짐)
                 로그인, [거래내역조회] - 달력조회 탭에서 사용중
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section v-if="opened">
    <div class="dropdown" :class="{ 'top-round-box': topRoundBox, half: !halfClose }">
      <div class="dropdown-content">
        <div
          class="dropdown-content-header"
          @click="() => {halfClose = topRoundBox?!halfClose : halfClose }"
        >
          <div class="close">
            <div v-if="topRoundBox" class="bar" />
            <i v-else class="icon icon-dropdown" @click="close()" />
          </div>
        </div>
        <div v-if="dropdownBody" class="dropdown-body">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </section>
</template>
<style type="scss" scoped></style>
<script>
import { BaseComponent } from "@/components/base-component";
import { mapFields } from "vuex-map-fields";
import ModalEvent from "@/components/modal-event";

export default {
  name: "dropdown",
  extends: BaseComponent,
  mixins: [ModalEvent],
  props: {
    opened: { type: Boolean, default: false },
    dropdownBody: { type: [Boolean], default: true },
    width: { type: String, default: "100%", required: false },
    height: { type: String, default: "auto", required: false },
    topRoundBox: { type: Boolean, default: false },
  },
  data() {
    return {
      active: "",
      halfClose: false,
    };
  },
  computed: {
    ...mapFields("accounts/calendarInq", ["calendarInq", "totalAmtShow", "RBF0404A40Date"]),
    hasCloseListener() {
      return this.$listeners && this.$listeners["close-button-clicked"];
    },
  },
  watch: {
    opened: {
      handler(newData) {
        if (newData) {
          if (process.browser) {
            this.removeBodyScroll();
          }
          this.active = "slide-up";
        } else {
          if (process.browser) {
            this.addBodyScroll();
          }
          this.active = "slide-down";
        }
      },
    },
  },
  beforeDestroy() {
    if (process.browser) {
      this.addBodyScroll();
    }
  },
  methods: {
    close() {
      if (this.hasCloseListener) {
        this.$emit("close-button-clicked", () => this.done());
      } else {
        this.done();
      }
      this.totalAmtShow = true;
      this.RBF0404A40Date = {}; //일별 거래내역조회 결과 초기화
      this.$emit("showAllRowCal", this.totalAmtShow);
    },
    done() {
      this.$emit("update:opened", false);
    },
  },
};
</script>
